/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathDeltaIcon16Regular = forwardRef('MathDeltaIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m6.446 3-4.373 8.445A1.75 1.75 0 0 0 3.627 14h8.746a1.75 1.75 0 0 0 1.554-2.555L9.554 3.001C8.9 1.74 7.099 1.74 6.446 3Zm.707 2.072-3.455 6.73a.5.5 0 0 0 .445.728h6.909a.5.5 0 0 0 .445-.728l-3.455-6.73a.5.5 0 0 0-.89 0Z" })));
});
